<template>
    <Modal ref="addCustomerModal" :title="modalTitle" :large="true">


            <template v-slot:body>

                <!-- סוג לקוח: a business customer is invoiced on the business fields typed here -->
                <CustomerTypeFields :customer="customer"></CustomerTypeFields>

                <div v-for="(contact,index) in contacts">
                    <h5>
                        איש קשר
                        {{ index +1 }}
                    </h5>
                    <CustomerContactFields :contact="contact"></CustomerContactFields>
                </div>


                <button @click="addContact" class="btn btn-secondary btn-sm">
הוסף
                </button>
&nbsp;
                <button @click="removeContact" class="btn btn-danger btn-sm">
הסר
                </button>


                

            </template>

            <template v-slot:buttons>
                <!-- closed from save() once the details validate, so a business customer without a
                     name keeps the modal (and the error) in front of the user -->
                <button @click="save" type="button" class="btn btn-primary">
                    שמור
                </button>
            </template>


    </Modal>
</template>

<script>

    const DEFAULT_FIRST_CONTACT_TITLE = 1; //first contact is bride, i don't think this is right

    import CustomerContactFields from './CustomerContactFields.vue';
    import CustomerTypeFields from './CustomerTypeFields.vue';
    import CustomerHandler from '../../modules/CustomerHandler';
    import { apiRequest } from '../../core/http/axios_api_v2';


    function initialState(){
        return {
                modalTitle: "לקוח חדש - הוספת אנשי קשר:",
                //סוג לקוח + the business fields (CustomerTypeFields edits them in place)
                customer: CustomerHandler.generateLocalEmptyBusinessDetails(),
                contacts: [
                    {
                        title: DEFAULT_FIRST_CONTACT_TITLE,   

                    }
                ],
            }
    }


    export default {
        name: "AddCustomerModal",
        data(){
            return initialState();
        },
        methods: {
            show(){
                this.$refs.addCustomerModal.show();
            },
            addContact (){

                

                let newContact = {};
                
                if (!this.contacts.length){

                    newContact.title = DEFAULT_FIRST_CONTACT_TITLE;

                } else if (this.contacts.length==1 && this.contacts[0].title==1){
                    
                    newContact.title = 2;

                }

                this.contacts.push(newContact);

            },
            removeContact (){
                this.contacts.pop();
            },
            async save(){

                // a business customer needs at least the business name
                if (!CustomerHandler.validateBusinessDetails(this, this.customer))
                    return;

                let businessDetails = {};
                CustomerHandler.businessFields.forEach(field => businessDetails[field] = this.customer[field]);

                // "this phone already exists" - ask before opening a second card for someone we
                // already have. Same question the full לקוח חדש page asks, just routed through the
                // global modal in App.vue (a modal inside this modal's slot would nest two of them).
                let phone = (this.contacts.find(contact => contact.phone) || {}).phone;
                let duplicates = phone ? await this.$handlers.customerHandler.findCustomersByPhone(phone) : [];

                if (duplicates.length) {

                    //this modal closes first - let it finish before the question opens, or two
                    //bootstrap modals overlap
                    this.$refs.addCustomerModal.hide();
                    await this.waitUntilClosed();

                    let answer = await new Promise(resolve =>
                        this.$root.$emit('askDuplicatePhone', phone, duplicates, resolve));

                    if (answer.choice == 'cancel')
                        return;

                    if (answer.choice == 'merge') {

                        let existing = duplicates.find(duplicate => duplicate.id == answer.customerId);

                        //the existing card's full contact list with these values folded into its
                        //blanks - nothing already on the card is overwritten
                        let contacts = this.$handlers.customerHandler.foldContactsIntoCustomer(
                            this.contacts, existing.contacts);

                        await apiRequest('post', `customers/contacts/${existing.id}`, contacts);

                        //business details typed here land on the existing card; a private form
                        //leaves whatever the card already has
                        if (CustomerHandler.isBusinessCustomer(this.customer))
                            await apiRequest('post', `customers/business-details/${existing.id}`, businessDetails);

                        this.$refs.addCustomerModal.hide();
                        this.$emit('savedNewCustomer', existing.id);
                        Object.assign(this.$data, initialState());
                        return;
                    }
                }

                //this is the actual save
                let customerId = await apiRequest('post','customers',{contacts:this.contacts, ...businessDetails});
                


                //checks on customerId..

                this.$refs.addCustomerModal.hide();

                this.$emit('savedNewCustomer',customerId);


                //reset component after save new customer, because if we add new customers, let them be new
                Object.assign(this.$data, initialState());



            },

            //resolves once this modal is fully closed (or right away if it already is)
            waitUntilClosed(){

                let modalElement = this.$refs.addCustomerModal.$el;

                if (!modalElement.classList.contains('show'))
                    return Promise.resolve();

                return new Promise(resolve => {
                    modalElement.addEventListener('hidden.bs.modal', resolve, { once: true });
                    setTimeout(resolve, 600);   //never hang on a missed event
                });
            }
        },
        components: {
            CustomerContactFields,
            CustomerTypeFields
        }

    }

</script>